/**
 * AccountNumberMask component module.
 * @module shared/components/AccountNumberMask
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {isEntitled} from '../reducers/user';

const _NumberMask = styled.span`
  &:hover {
    ${props => props.readOnly ? 'cursor: default;' : 'cursor: pointer;'}
  }
`;

const AccountNumberMask = props => {
  const {number, institutionName, institution} = props;
  const [masked, setMasked] = React.useState(1);

  const maskedNumber = React.useMemo(() => {
    if (!masked) {
      return number;
    }
    if (!number) {
      return '-';
    }
    if ((institution?.name || institutionName) === 'RBC Clearing & Custody'
      && isEntitled([{group: 'account', feature: 'rbc_number_five_chars', access: 'r'}])) {
      return 'xxx' + number.substr(-5, 5);
    }

    return 'xxxx' + number.substr(-4, 4);
  }, [number, masked]);

  if (isEntitled([{group: 'account', feature: 'fullAccNum', access: 'r'}])) {
    return <span className={props.className}>{number}</span>;
  }

  return <_NumberMask
    className={props.className}
    onClick={e => {
      e.stopPropagation();
      setMasked(current => !current);
    }}>{maskedNumber || '-'}</_NumberMask>;
};

export default AccountNumberMask;

AccountNumberMask.propTypes = {
  /**
   * Account Number
   */
  number: PropTypes.string.isRequired,
  /**
   * Account Institution Name/Title
   */
  institutionName: PropTypes.string,
  /**
   * Account Institution Object
   */
  institution: PropTypes.object,
  /**
   * Whether AccountNumberMask is read-only
   */
  readOnly: PropTypes.bool,
  className: PropTypes.string,
};
